import script from "./accountDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./accountDetails.vue?vue&type=script&setup=true&lang=js"

import "./accountDetails.vue?vue&type=style&index=0&id=13ec46a6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13ec46a6"]])

export default __exports__